import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import {
  fetchTranslationsFor,
  translatePage,
} from "/WebInterface/new-ui/modules/localizations/localizations.js";

window.translations = {};
window.locale = "";

_$("body").ready(async () => {
  // Translate the page to the default locale

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const lang = urlParams.get("lang");

  if (lang) {
    _$("html").attr("lang", lang);
  }
  setLocale(lang);
});

const setLocale = async (newLocale) => {
  if (newLocale === locale) return;

  const newTranslations = await fetchTranslationsFor(newLocale);
  _$("html").attr("lang", newLocale);

  window.locale = newLocale;
  window.translations = newTranslations;
  translatePage();
};

export default setLocale;
